import './App.css'
import Pages from "@/pages/index.jsx"
import { Toaster } from "@/components/ui/toaster"
import { AuthProvider, useAuth } from "@/lib/AuthContext"
import { ErrorBoundary } from "@/components/ui/ErrorBoundary"
import PushInitializer from "@/components/ai/v2/PushInitializer"
import { AI_V2_ENABLED as AI_V2 } from "@/lib/featureFlags"
import ConsentManager from "@/components/consent/ConsentManager"
import { MaintenanceBanner } from "@/components/feature/MaintenanceBanner"
import PlanLimitModal from "@/components/plan/PlanLimitModal"

function AIV2Bootstrap() {
  const { isAuthenticated } = useAuth();
  if (!AI_V2 || !isAuthenticated) return null;
  return <PushInitializer enabled />;
}

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <MaintenanceBanner />
        <Pages />
        <AIV2Bootstrap />
        <Toaster />
        <PlanLimitModal />
        <ConsentManager />
      </AuthProvider>
    </ErrorBoundary>
  )
}

export default App
